var treedata = {
    "name": "技术路线",
    "children": [
      {
        "name": "V1",
        "children": [
          {
            "name": "V1.0-共识管理",
            "children": [{
               "name":"center",
               "children": [
                {"name": "文件打开数已设置最大值6.5w多，依然报文件打开数过多，导致节点不打包"},
                {"name": "p2p接收不到消息-ip地址改变，无法连接（linux虚拟机的虚拟网络ip"},
                {"name": "p2p接收不到消息-ZMQ消息时延设置问题"},
             ]
            },
            {
              "name":"node",
              "children": [
               {"name": "文件打开数已设置最大值6.5w多，依然报文件打开数过多，导致节点不打包"},
               {"name": "p2p接收不到消息-ip地址改变，无法连接（linux虚拟机的虚拟网络ip"},
               {"name": "p2p接收不到消息-ZMQ消息时延设置问题"},
            ]
           },
          ]
            
          },
          {
            "name": "V1.1-配置中心建设",
            "children":[
              {"name": "center",
              "children": [
                {"name": "getAllZoneID netty报异常，数据太长，自动丢弃 中央返回的数据量过大警告: An exceptionCaught() event was fired, and it reached at the tail of the pipeline. It usually means the last handler in the pipeline did not handle the exception.", "value": 39},
                {"name": "购买交易不上链-存入mtxpool时检测到双花"},
                {"name": "购买交易不上链-在txpool中检测到双花"},
                {"name": "节点只备案一个block，但是该block在step4临时磁盘文件中找不到（在验证step2完成时写入临时磁盘）"},]
            },
            ]
          },
        ]
      },
      {
        "name": "V2",
        "children": [
          {
            "name": "V2.0-多节点并行",
            "children":[
              {"name": "node",
            "children": [
              {"name": "节点上链正常，但是依然有时不对外提供服务 (定时任务时间是60s， reportblock是在step1写入磁盘) "},
              {"name": "节点在存储高度为3557的reportblock后出现上诉error， 但是localMaxblock是正常的，直到存储到高度为3565的reportblock后，localMaxblock彻底不正常，变成几十或几千，之后有变过一次正常，但概率非常小。"},
              {"name": "节点突然自己挂掉，log日志没有打印，但是服务端口还在"},]
              }
            ]
          },
          {
            "name": "V2.1-数据库主从",
            "children":[
              {"name": "DB",
            "children": [
              {"name": "节点验签返回false"},
              {"name": "日志存储center 节点 wallet web 在正常连接mogodb的情况下，mogodb突然挂掉，则其他会运行变慢。"},
              {"name": "节点无法对外提供服务节点一直在更新block高度为1的block   在刚启动时就这样，但是最新的block高度是一万多。 "},
              {"name": "节点打包正常，备案正常，但是真正上链的block很少，五六分钟，或十几分钟上链一个"},]
              }]
          },
          {
            "name": "V2.2-合约在线编辑、编译平台",
            "children":[
              {"name": "好奇",
            "children": [
              {"name": "node初始化慢"},
              {"name": "节点重启，所有余额都没啦"},
              {"name": "center数据库中节点1状态修改为cancel，但是节点2仍然会发消息给节点1"},
            ]
          }]
          },
        ]
      },
      {
        "name": "V3",
        "children": [
          {
            "name": "V3.0-交易撤销机制",
            "children": [
              {"name": "web","children":[
              {"name": "严重: GC overhead limit exceeded6993516 java.lang.OutOfMemoryError: GC overhead limit exceeded"},
              {"name": "将广播交易与普通发送交易使用不同的指令字"},
              {"name": "levelDB在进行文件合并时会打开删除文件，如果当db正在删除文件时，调用db.close()，此时会造成文件打开过多。"},
              {"name": "Runtime.getRuntime().addShutdownHook(new Thread(new Runnable()方法执行了；节点一打包就挂掉"},]
              }]
          },
          {
            "name": "V3.1-服务集成",
            "children": [
              {"name": "web","children":[
              {"name": "无法打印日志"},
              {"name": "文件打开数已设置最大值6.5w多，依然报文件打开数过多，导致节点不打包"},
              {"name": "OverlappingFileLockException when open LevelDB"}, ]
            }]
          },
        ]
      },
      {
        "name": "V4",
        "children": [
          {
            "name": "V4.0-数据中心",
            "children": [
              {"name": "deepsea","children":[
              {"name": "The class java.io.DeleteOnExitHook, loaded by <system class loader>, occupies 1.79 GB (59.17%) bytes. The memory is accumulated in one instance of java.util.LinkedHashMap loaded by <system class loader>"},
              {"name": "protobuf转换异常Protocol message contained an invalid tag（zero）"},
              {"name": "所有节点和wallet均和节点36通讯中断，节点36仍然正常打包"},
              {"name": "内存溢出"},
            ]
          }]
          },
        ]
      },
      {
        "name": "V5",
        "children": [
          {
            "name": "V5.0-服务路由",
            "children": [
              {"name": "center","children":[
              {"name": "文件打开数已设置最大值6.5w多，依然报文件打开数过多，导致节点不打包"},
              {"name": "生产环境时间片被删掉 "},
              {"name": "节点备案正常，但是确认表中没有值写入。"},
            ]}]
          },
          {
            "name": "V5.1-多分区并行",
            "children": [
              {"name": "center","children":[
              {"name": "文件打开数已设置最大值6.5w多，依然报文件打开数过多，导致节点不打包"},
              {"name": "Center计算选择blcok确认也停止。"},
              {"name": "时间片表该时间段的时间片是缺失的。"},

            ]}]
          },
        ]
      },
      {
        "name": "V6",
        "children": [

          {
            "name": "V6.0-cache机制",
            "children": [
              {"name": "web","children":[
              {"name": "13:14:49.391 [pool-733-thread-1] INFO  [172.17.97.143 8334 00-16-3E-10-05-4D node com.bc.p2p.base.service.StepT03] [com.bc.p2p.base.service.StepT03.doStepT03(StepT03.java:152)] - doStepT03 is done. and total time is 331797"},
              {"name": "Center报如下错误信息，并且每隔15分钟出现该现象一次"},
              {"name": "文件打开数已设置最大值6.5w多，依然报文件打开数过多，导致节点不打包"},
            ]}]
          },
          {
            "name": "V6.1-服务中间件",
            "children": [
              {"name": "center","children":[
              {"name": "钱包打包有问题"},
              {"name": "wallet刚启动去节点下载全部的utxo"},
              {"name": "钱包打包有问题"},
            ]}]
          },
          {
            "name": "V6.2-负载均衡",
            "children": [
              {"name": "center","children":[
              {"name": "flume传输的日志数据量大，flume采用管道采用的缓存模式，"},
              {"name": "center在打包之前，有接收到备案block，但是在他打包的时候它认为没有接收到备案的block。"},
              {"name": "wallet刚启动去节点下载全部的utxo，因为utxo特别大，导致节点36通信中断"},
            ]}]
          },
        ]
      },
      {
        "name": "V7",
        "children": [
          {
            "name": "V7.0-日志收集",
            "children": [
              {"name": "deepsea","children":[
              {"name": "Center报如下错误信息，并且每隔15分钟出现该现象一次"},
              {"name": "文件打开数已设置最大值6.5w多，依然报文件打开数过多，导致节点不打包"},
              {"name": "center竞争结果表中的block有重复高度"},
            ]}]
          },
          {
            "name": "V7.1-多活",
            "children": [
              {"name": "center","children":[
              {"name": "将广播交易与普通发送交易使用不同的指令字"},
              {"name": "levelDB在进行文件合并时会打开删除文件，如果当db正在删除文件时，调用db.close()，此时会造成文件打开过多。"},
              {"name": "Runtime.getRuntime().addShutdownHook(new Thread(new Runnable()方法执行了；节点一打包就挂掉"},
            ]},
            {"name": "node","children":[
              {"name": "将广播交易与普通发送交易使用不同的指令字"},
              {"name": "levelDB在进行文件合并时会打开删除文件，如果当db正在删除文件时，调用db.close()，此时会造成文件打开过多。"},
              {"name": "Runtime.getRuntime().addShutdownHook(new Thread(new Runnable()方法执行了；节点一打包就挂掉"},
            ]},
            {"name": "deepsea","children":[
              {"name": "将广播交易与普通发送交易使用不同的指令字"},
              {"name": "levelDB在进行文件合并时会打开删除文件，如果当db正在删除文件时，调用db.close()，此时会造成文件打开过多。"},
              {"name": "Runtime.getRuntime().addShutdownHook(new Thread(new Runnable()方法执行了；节点一打包就挂掉"},
            ]},
            {"name": "DB","children":[
              {"name": "将广播交易与普通发送交易使用不同的指令字"},
              {"name": "levelDB在进行文件合并时会打开删除文件，如果当db正在删除文件时，调用db.close()，此时会造成文件打开过多。"},
              {"name": "Runtime.getRuntime().addShutdownHook(new Thread(new Runnable()方法执行了；节点一打包就挂掉"},
            ]},
          ]
          },
        ]
      },
      {
        "name": "V8",
        "children": [
          {
            "name": "V8.0-心跳检测",
            "children": [
              {"name": "Benchmark","children":[
              {"name": "迭代调用时，有删除或添加操作"},
              {"name": "虽然center是定期刷新数据库，但是节点更新nodes时不删除本地node"},
              {"name": "center数据库中节点1状态修改为cancel，但是节点2仍然会发消息给节点1"},
            ]}]
          },

          {
            "name": "V8.1-防重复提交，防重放攻击",
            "children": [
              {"name": "hawk","children":[
              {"name": "节点1传送给节点2的hash值没有编码，但是在节点2进行了解码"},
              {"name": "updataChain 陷入死循环，也可能是因为intChain没有完成"},
              {"name": "getZoneNodes 方法，每次都启动一个线程，但是却没有关闭"},
            ]}]
          },
          {
            "name": "V8.2-千寻评测",
            "children": [
              {"name": "hawk","children":[
              {"name": "center在打包之前，有接收到备案block，但是在他打包的时候它认为没有接收到备案的block。"},
              {"name": "节点打包正常，备案正常，但是真正上链的block很少，五六分钟，或十几分钟上链一个"},
              {"name": "节点线程不执行可能原因"},
            ]}]
          },
        ]
      },
      {
        "name": "V9",
        "children": [
          {
            "name": "V9.0-基石对等评测",
            "children": [
              {"name": "getAllZoneID netty报异常，数据太长，自动丢弃 中央返回的数据量过大警告: An exceptionCaught() event was fired, and it reached at the tail of the pipeline. It usually means the last handler in the pipeline did not handle the exception.", "value": 39},
              {"name": "购买交易不上链-存入mtxpool时检测到双花"},
              {"name": "购买交易不上链-在txpool中检测到双花"},
            ]
          },
          {
            "name": "V9.1-监控可视化",
            "children": [
              {"name": "文件打开数已设置最大值6.5w多，依然报文件打开数过多，导致节点不打包"},
              {"name": "p2p接收不到消息-ip地址改变，无法连接（linux虚拟机的虚拟网络ip"},
              {"name": "p2p接收不到消息-ZMQ消息时延设置问题"},
            ]
          },
          {
            "name": "V9.2-报警机制",
            "children": [
              {"name": "center","children":[
              {"name": "center竞争结果表中的block有重复高度"},
              {"name": "节点打包正常，备案正常，但是真正上链的block很少，五六分钟，或十几分钟上链一个"},
              {"name": "center的结果竞争表中，连着十几个都是115打的包，又连着几十个是113打的包"},
            ]},
            {"name": "wallet","children":[
              {"name": "center竞争结果表中的block有重复高度"},
              {"name": "节点打包正常，备案正常，但是真正上链的block很少，五六分钟，或十几分钟上链一个"},
              {"name": "center的结果竞争表中，连着十几个都是115打的包，又连着几十个是113打的包"},
            ]},
          
            {"name": "deepase","children":[
              {"name": "center竞争结果表中的block有重复高度"},
              {"name": "节点打包正常，备案正常，但是真正上链的block很少，五六分钟，或十几分钟上链一个"},
              {"name": "center的结果竞争表中，连着十几个都是115打的包，又连着几十个是113打的包"},
            ]},
          
            {"name": "hawk","children":[
              {"name": "center竞争结果表中的block有重复高度"},
              {"name": "节点打包正常，备案正常，但是真正上链的block很少，五六分钟，或十几分钟上链一个"},
              {"name": "center的结果竞争表中，连着十几个都是115打的包，又连着几十个是113打的包"},
            ]},
          
            {"name": "web","children":[
              {"name": "center竞争结果表中的block有重复高度"},
              {"name": "节点打包正常，备案正常，但是真正上链的block很少，五六分钟，或十几分钟上链一个"},
              {"name": "center的结果竞争表中，连着十几个都是115打的包，又连着几十个是113打的包"},
            ]},
          
          ]
          },
        ]
      },{
        "name": "V10",
        "children": [
          {
            "name": "V10.0-自动化部署",
            "children": [
              {"name": "节点打包正常，备案正常，但是真正上链的block很少"},
              {"name": "p2p接收不到消息-ZMQ消息时延设置问题"},
            ]
          },
          {
            "name": "V10.1-灰度发布",
            "children": [
              {"name": "web","children":[
              {"name": "protobuf转换异常Protocol message contained an invalid tag（zero）"},
              {"name": "所有节点和wallet均和节点36通讯中断，节点36仍然正常打包"},
              {"name": "内存溢出"},
            ]}]
          },
          {
            "name": "V10.2-自动化测试",
            "children": [
              {"name": "Benchmark","children":[
              {"name": "wallet刚启动去节点下载全部的utxo"},
              {"name": "钱包打包有问题"}
            ]}]
          },
        ]
      },
      
      {
        "name": "V11",
        "children": [
          {
            "name": "V11.0-限流与熔断",
            "children": [
              {"name": "web"}]
          },
          {
            "name": "V11.1-数据挖掘、数据分析",
            "children": [
              {"name": "deepsea"}]
          },

        ]
      },
      {
        "name": "V12",
        "children": [
          {
            "name": "V12.0-链上数据交互",
            "children": [
              {"name": "node"}]
          },
          {
            "name": "V12.1-跨合约数据交互",
            "children": [
              {"name": "node"}]
          },
        ]
      },
    ]
  }
export {treedata}
